( function ($) {

	/** Sticky Header **/
	if ( $(window).scrollTop() <= 80 ) {
		$( '.main-header-wrapper' ).removeClass( '__sticky' );
	} else {
		$( '.main-header-wrapper' ).addClass( '__sticky' );
	}

	$( window ).scroll( function() {
		if ( $(window).scrollTop() <= 80 ) {
			$( '.main-header-wrapper' ).removeClass( '__sticky' );
		} else {
			$( '.main-header-wrapper' ).addClass( '__sticky' );
		}
	} );


	$( document ).ready( function() {
		/** subpages banner swiper slider **/
		var swiper = new Swiper('.__page_slider_banner', {
		    loop: true,
		    loopedSlides: 3,
		    spaceBetween: 0,
			speed: 1500,
			autoplay: {
				delay: 7000,
				disableOnInteraction: false,
			},
		    //navigation: {
		    //    nextEl: '.swiper-btn-next',
		    //    prevEl: '.swiper-btn-prev',
      		//},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
		});

		
		/** header main menu superfish **/
	    $('ul#menu-main-menu').superfish({
	    	delay			: 600,
	    	animation		: {opacity:'show', height:'show'},
	    	animationOut	: {opacity:'hide'},
	    	speed			: 'fast'
	    });


		/** subpages swiper slider gallery **/
		// var gallerySlider = new Swiper('.__slider_gallery', {
		// 	slidesPerView: 1,
		//     spaceBetween: 13,
		//     loop: true,
		//     loopedSlides: 3,
		//     speed: 500,
		//     slideToClickedSlide: false,
		//     navigation: {
		//         nextEl: '.swiper-btn-next',
		//         prevEl: '.swiper-btn-prev',
  //     		},
		// 	pagination: {
		// 		el: '.swiper-pagination',
		// 		clickable: true,
		// 	},
		// 	breakpoints: {
		// 			// when window width is >= 512px
		// 			512: {
		// 			slidesPerView: 2,
		// 			spaceBetween: 13
		// 		},
		// 			// when window width is >= 768px
		// 			769: {
		// 			slidesPerView: 3,
		// 			spaceBetween: 13
		// 		},
		// 			// when window width is >= 1024px
		// 			1024: {
		// 			slidesPerView: 3,
		// 			spaceBetween: 13
		// 		},
		// 	}
		// });


		/** autoheight repeater content layout */
		// $( ".repeater-content-section .rc-content" ).autoHeight({
		// 	'onResize': true,
		// });
	} );
	
	
	$( window ).resize( function() {
	    
	} );
	
	
	$( window ).load( function() {
	    
	} );
	
	
	$( document ).scroll( function() {

	} );

} ( jQuery ) );



/** moby mobile responsive menu **/
var $ = jQuery;

var mobyMenu = new Moby( {
	menu              : $( '#mobile-menu' ), // The menu that will be cloned
	mobyTrigger       : $( '#open-mobile-menu' ), // Button that will trigger the Moby menu to open
	menuClass		  : 'left-side',
	subMenuOpenIcon   : '<i class="fa fa-caret-down"></i>',
	subMenuCloseIcon  : '<i class="fa fa-caret-up"></i>',
	template          : '<div class="moby-close"><span class="moby-close-icon"></span></div><div class="moby-wrap"><div class="moby-menu"></div></div>'
} );